<div class="btn-group ms-3" *ngIf="(hasNext() || hasPrev())">
    <button class="btn btn-outline-secondary rounded-start-3" type="button" (click)="prev()" [disabled]="!hasPrev()">
        <app-icon class="icon-blue md-icon" name="angle-left"></app-icon>
    </button>
    <button class="btn btn-outline-secondary px-3" type="button" (click)="first()"> {{getPage()}} </button>
    <button class="btn btn-outline-secondary rounded-end-3" type="button" (click)="next()" [disabled]="!hasNext()">
        <app-icon class="icon-blue md-icon" name="angle-right"></app-icon>
    </button>
</div>
